import type {
  PluginOption,
  TransformResult,
} from 'vite';

export const AUTOMATION_DIRECTIVE_ATTRIBUTE = 'data-qa-auto-id';
export const AUTOMATION_DIRECTIVE_NAME = 'dataQaAutoId';
export const AUTOMATION_EXCLUDED_ROOT_ELEMENT_NAMES = ['PDialog', 'VDialog', 'PConfirmPopup', 'PToast', 'RouterView', 'slot', 'Portal', 'Transition'];
export const AUTOMATION_EXCLUDED_COMPONENT_NAMES = ['App'];

export function AutomationPlugin(): PluginOption {
  return {
    name: 'automation-plugin',
    enforce: 'pre',
    transform(source, resourcePath): TransformResult | string {
      if (resourcePath.includes('.vue') && source.includes('<template>')) {
        const templateStartTag = '<template>';
        const templateEndTag = '</template>';
        // console.log(resourcePath)
        const startIndex = source.indexOf(templateStartTag);
        const endIndex = source.lastIndexOf(templateEndTag);

        if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex)
          return source;

        const tplContentStart = startIndex + templateStartTag.length;
        const templateSource = source.slice(tplContentStart, endIndex);

        const re = /<([\w-]+)/;
        const componentRootElementName = templateSource.match(re)?.pop();

        if (!componentRootElementName)
          return source;

        const componentName = resourcePath.slice(
          resourcePath.lastIndexOf('/') + 1,
          resourcePath.lastIndexOf('.'),
        )
          .replace(/\W/g, '-');

        if (AUTOMATION_EXCLUDED_ROOT_ELEMENT_NAMES.includes(componentRootElementName) || AUTOMATION_EXCLUDED_COMPONENT_NAMES.includes(componentName)) {
          return source;
        }

        const updatedTemplateSource = templateSource.replace(re, `<$1 v-${AUTOMATION_DIRECTIVE_ATTRIBUTE}="'${componentName}'"`);

        return {
          code: source.slice(0, tplContentStart) + updatedTemplateSource + source.slice(endIndex),
          map: null,
        };
      }

      return {
        code: source,
        map: null,
      };
    },
  };
}
